export const GETHR = "GETHR"
export const GETMYHR = "GETMYHR"
export const ADD_HR = "ADD_HR";
export const UPDATE_HR_SUCCESS = "UPDATE_HR_SUCCESS";
export const DELETE_HR = "DELETE_HR";

